import React from "react";
import { Carousel } from "../../common/components/Carousel";

interface UpgradesProps {
	packageName: string;
	modules: {
		content: string;
		list?: string[];
		title: string;
		url?: string;
	}[];
	children?: React.ReactNode;
}

export function Upgrades({ packageName, modules, children }: UpgradesProps) {
	const upgrades = modules.map((item, index) => {
		const { title, content, list, url } = item;
		let bullets: React.ReactNode;

		if (list) {
			bullets = (
				<ul className="ticks ticks--small">
					{list.map((item, index) => (
						<li key={index}>{item}</li>
					))}
				</ul>
			);
		}

		return (
			<div key={index} className="card typography">
				<p className="title">{title}</p>
				<p className="content">{content}</p>
				{bullets}
				{url && (
					<a href={url} className="link">
						Explore
					</a>
				)}
			</div>
		);
	});
	const multipleRows = modules.length > 2;

	return (
		<section className="section--upgrades section--dark">
			<div className="container">
				<h2 className="section-title">
					More ways to enhance your data
				</h2>
				<p className="section-description">
					You can upgrade your {packageName} with the following data:
				</p>

				<Carousel
					options={{
						className: multipleRows ? "multiple-rows" : "",
						dots: false,
						rows: multipleRows ? 2 : 1,
						slidesToShow: 1,
						slidesPerRow: 2,
						responsive: [
							{
								breakpoint: 768,
								settings: {
									className: "",
									rows: 1,
									slidesPerRow: 1,
									slidesToScroll: 2,
									slidesToShow: 2,
								},
							},
							{
								breakpoint: 576,
								settings: {
									className: "",
									rows: 1,
									slidesPerRow: 1,
									slidesToScroll: 1,
									slidesToShow: 1,
								},
							},
						],
					}}
					slides={upgrades}
				/>
			</div>
			{children}
		</section>
	);
}
